import { useCallback } from 'react';
import { urls } from '@/constants/urls';
import { useCurrentOrganisation } from '@/hooks/use-current-organisation';
import { useCurrentGroup } from './use-current-group';

/**
 * Gets the URL for a unit. Units are not always in the context of a group,
 * so we provide an over-ride.
 *
 * This seems a little janky so we should consider refactoring this
 */
export const useUnitUrlComposer = () => {
  const { isUsingOrganisationOverride, organisation } =
    useCurrentOrganisation();
  const { data: group } = useCurrentGroup(); // TODO: this doesn't need to fetch the actual group, same for other url copmosition hooks
  const orgId = organisation?.id as number;
  const groupId = group?.id as number;
  return useCallback(
    (unitId: number, groupIdOverride?: number) =>
      isUsingOrganisationOverride
        ? urls.organisations.organisation.groups.group.unit.compose(
            orgId,
            groupIdOverride ?? groupId,
            unitId,
          )
        : urls.groups.group.unit.compose(groupIdOverride ?? groupId, unitId),
    [isUsingOrganisationOverride, orgId, groupId],
  );
};
